export default __webpack_public_path__ + "static/media/sollet.0a8582f7.svg";